import {createSelector, MemoizedSelector} from '@ngrx/store';
import {cultivosAdapter, CultivosState} from './cultivos.state';

import {FeaturesState, selectFeatures} from '../../../features.state';
import {Cultivo} from "../../../../../chacra-core/models/cultivos";

export const getError = (state: CultivosState): any => state.error;

export const getIsLoading = (state: CultivosState): boolean =>
  state.isLoading;

export const selectCultivosState = createSelector(selectFeatures,
  (state: FeaturesState) => state.cultivos
);

export const selectAllCultivos: (state: object) => Cultivo[] = cultivosAdapter.getSelectors(
  selectCultivosState
).selectAll;

export const selectCultivosError: MemoizedSelector<object, any> = createSelector(
  selectCultivosState,
  getError
);

export const selectCultivosIsLoading: MemoizedSelector<object, any> = createSelector(
  selectCultivosState,
  getIsLoading
);
